export default "__VITE_ASSET__NxxlvRGq__"